import { RadioField, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getSummary } from './get_summary';
import { TimezonePicker } from './picker';
const radioButtonV3StyleCss = "r17hfcfd";
const radioButtonCss = "r1r8lqyt";
const RadioButton = forwardRef((props, ref) => {
  const {
    v3Style,
    ...restProps
  } = props;
  return <RadioField ref={ref} {...restProps} className={classNames(radioButtonCss, {
    [radioButtonV3StyleCss]: v3Style
  }, props.className)} />;
});
const LockTimezoneLocked = () => {
  const {
    values: {
      lockTimezoneStatus
    }
  } = useFormContext();
  return getSummary(lockTimezoneStatus);
};
const LockTimezoneField = ({
  ownerType,
  v3Style,
  isMETParent = false
}) => {
  const showLockTimezonePicker = ownerType !== 'User' && !isMETParent;
  return <>
      <RadioButton name="lockTimezoneStatus" value="local" label={I18n.t('publisher.event_types.availability.timezone_fieldset.local_label')} v3Style={v3Style} />
      <RadioButton name="lockTimezoneStatus" value="locked" label={I18n.t('publisher.event_types.availability.timezone_fieldset.locked_label')} v3Style={v3Style} />
      {showLockTimezonePicker && <TimezonePicker />}
    </>;
};
export const LockTimezone = ({
  isLocked,
  ...props
}) => !isLocked ? <LockTimezoneField {...props} /> : <LockTimezoneLocked {...props} />;

require("./lock_timezone.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./lock_timezone.js");